import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: ``,
    name: 'MOLD_SPOTCHECK_LIST',
    method: 'GET',
  });

  const fetchData = function () {
    if (params) {
      let url = `/api/maintain/moldspotcheck`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [isRequestSuccessed, data || [], fetchData];
});
